import {
  BarChartCard,
  BasicBarChartWithLabelCard,
  MultipleBarChartCard,
  StackBarChartCard,
} from "app/Components/ChartCard/ChartCard";
import { WidgetCard } from "app/Components/EhsDashboard/Global/Widgets";
import PieChartWithModal from "app/Components/PieChartWithModal/PieChartWithModal";
import { GlobalDashboardService } from "app/_services/GlobalDashboardService/GlobalDashboardService";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  barChartDataFormat,
  BasicBarChartWithLabelDataFormat,
  BasicBarChartWithLabelMonthDataFormat,
  pieChartDataWithModal,
  stackChartDataFormat,
} from "../Comman/config";
import DashboardNav from "../Comman/DashboardNav";
import { pageOneChartList, pageTwoChartList, widgetData } from "./Constant";
import RightFilter from "../RightFilter";
import {
  IS_USER_SITE_HO,
  IS_USER_SITE_MINES,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import { useSelector } from "react-redux";
import moment from "moment";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const TMDashboard = () => {
  const [page, setPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [chart, setChart] = useState({});
  const [allSite, setAllSite] = useState([]);
  const [haveAccessToSite, setHaveAccessToSite] = useState([]);
  const [currentSelectedSite, setCurrentSelectedSite] = useState({});
  const [loading, setLoading] = useState(true);
  const filterClick = (value) => {
    setShowFilter(value);
  };
  const pageValueFun = (value) => {
    setPage(value);
  };
  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  useEffect(() => {
    getAllSitesWithAccess().then((res) => {
      setAllSite(res?.data?.availableSites);
    });
  }, []);

  useEffect(() => {
    const getSiteData = allSite?.find((d) => d.id == globalSelectedSiteId);
    setCurrentSelectedSite(getSiteData);
    // pageValueFun(getSiteData?.siteType == 3 ? 2 : 1);
    const haveAccessToSiteArray =
      getSiteData?.siteType == 1
        ? allSite?.map((d) => {
            return d.id;
          })
        : getSiteData?.siteType == 2
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId || d.parentSiteId == globalSelectedSiteId)
                return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : getSiteData?.siteType == 3
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId) return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : [];

    setHaveAccessToSite(haveAccessToSiteArray);
  }, [allSite, globalSelectedSiteId]);

  const dashboardData = useCallback(
    async (filter) => {
      let obj = {
        startDate: filter?.startDate,
        endDate: filter?.endDate,
        siteId: filter?.siteId
          ? filter?.siteId
          : globalSelectedSiteId
          ? haveAccessToSite
          : null,
      };
      if (
        JSON.stringify(obj) === JSON.stringify({ siteId: [] }) ||
        JSON.stringify(obj) === JSON.stringify({ siteId: null })
      ) {
        return;
      }

      let response = await GlobalDashboardService.trainingDashboard(obj);

      if (response && response.status && response.data) {
        const dashboardData = response.data;
        // console.log("dataaaaa", response.data);

        let holdNulll = pageOneChartList?.map((item) => {
          setChart((prev) => ({
            ...prev,
            [item?.value]:
              item?.type == "stack"
                ? stackChartDataFormat(dashboardData[item?.value])
                : item?.type == "barWithLabel"
                ? BasicBarChartWithLabelDataFormat(dashboardData[item?.value])
                : item?.type == "bar"
                ? barChartDataFormat(dashboardData[item?.value])
                : item?.type == "pie"
                ? pieChartDataWithModal(dashboardData[item?.value])
                : "No chart",
          }));
        });
        let holdNull = pageTwoChartList?.map((item) => {
          setChart((prev) => ({
            ...prev,
            [item?.value]:
              item?.type == "stack"
                ? stackChartDataFormat(dashboardData[item?.value])
                : item?.type == "barWithLabel"
                ? BasicBarChartWithLabelDataFormat(dashboardData[item?.value])
                : item?.type == "barWithLabelMonth"
                ? BasicBarChartWithLabelMonthDataFormat(dashboardData[item?.value])
                : item?.type == "bar"
                ? barChartDataFormat(dashboardData[item?.value])
                : item?.type == "pie"
                ? pieChartDataWithModal(dashboardData[item?.value])
                : "No chart",
          }));
        });

        setChart((prev) => ({
          ...prev,
          dashboardData: dashboardData,
          widgetData: widgetData?.map((item) => {
            return {
              value: dashboardData[item?.value],
              name: item?.name,
              icon: item?.icon,
            };
          }),
        }));
      }
      setLoading(false);
    },
    [globalSelectedSiteId, haveAccessToSite]
  );

  useEffect(() => {
    dashboardData();
  }, [dashboardData]);

  const applyFilter = (filter) => {
    dashboardData(filter);
  };
  return (
    <>
      <Row>
        <Col lg={showFilter ? 9 : 12}>
          <Row>
            <Col lg={12}>
              <DashboardNav
                screenCount={
                  (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                    ? true
                    : false) || IS_USER_SITE_MINES()
                    ? 1
                    : 2
                }
                pageBool={pageValueFun}
                onFilterBool={filterClick}
                page={page}
                dashboardName="Training Management"
                id={"screen_" + page}
              />
            </Col>
          </Row>
          {!loading ? (
            <>
              {!IS_USER_SITE_MINES() &&
                (globalSelectedSiteId ? currentSelectedSite?.siteType != 3 : true) &&
                page == 1 && (
                  <Row className="screenOne" id={"screen_" + page}>
                    {pageOneChartList?.map((item, idx) => {
                      if (IS_USER_SITE_HO()) {
                        return item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "bar" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customeTool={item?.customeTool}
                              customToolTip={chart[item?.value]?.customToolTip}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "pie" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <PieChartWithModal
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        ) : (
                          "no chart"
                        );
                      } else if (!item?.isHo && !IS_USER_SITE_HO()) {
                        return item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "bar" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            key={idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customeTool={item?.customeTool}
                              customToolTip={chart[item?.value]?.customToolTip}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "pie" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <PieChartWithModal
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        ) : (
                          "no chart"
                        );
                      }
                    })}

                    {/* {pageTwoChartList?.map((item, idx) => (
                <Col key={idx} md={6} className="mb-4 pb-2">
                  <PieChartWithModal title={item.title} seriesData={chart[item?.value] || []} customLabelFalse={true} isCustomLegend={true} />
                </Col>
              ))} */}
                  </Row>
                )}
              {(((IS_USER_SITE_MINES() ||
                (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                  ? true
                  : false)) &&
                page == 1) ||
                page == 2) && (
                <Row className="screentwo m-0" id={"screen_" + page}>
                  <Col lg={12} className="widgetContainer mt-3 p-0">
                    <WidgetCard
                      isFilterClick={showFilter}
                      widgetData={chart?.widgetData}
                    />
                  </Col>

                  <Row>
                    {pageTwoChartList?.map((item, idx) =>
                      item?.type == "stack" ? (
                        <Col lg={6} key={idx} id={"main_" + idx} className="mb-4 pb-2">
                          <StackBarChartCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            categoryData={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        </Col>
                      ) : item?.type == "barWithLabel" ? (
                        <Col
                          lg={item?.isMines ? 12 : 6}
                          id={"main_" + idx}
                          key={idx}
                          className="mb-4 pb-2"
                        >
                          <BasicBarChartWithLabelCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            customeTool={item?.customeTool}
                            customToolTip={chart[item?.value]?.customToolTip}
                            category={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        </Col>
                      ) : item?.type == "barWithLabelMonth" ? (
                        <Col
                          lg={item?.isMines ? 12 : 6}
                          id={"main_" + idx}
                          key={idx}
                          className="mb-4 pb-2"
                        >
                          <BasicBarChartWithLabelCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            // category={chart[item?.value]?.categoryData?.map((d) => {
                            //   console.log("BasicBarChartWithLabelCard", d, moment(d, "YYYY-MM").format("MMM YYYY"));
                            //   return moment(d, "YYYY-MM").format("MMM YYYY")
                            // })}
                            seriesData={chart[item?.value]?.data}
                          />
                        </Col>
                      ) : item?.type == "bar" ? (
                        <Col
                          lg={item?.isMines ? 12 : 6}
                          id={"main_" + idx}
                          key={idx}
                          className="mb-4 pb-2"
                        >
                          <BarChartCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            categoryData={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        </Col>
                      ) : item?.type == "pie" ? (
                        <Col key={idx} md={6} id={"main_" + idx} className="mb-4 pb-2">
                          <PieChartWithModal
                            title={item.title}
                            id={"main_" + idx}
                            seriesData={chart[item?.value] || []}
                            customLabelFalse={true}
                            isCustomLegend={true}
                          />
                        </Col>
                      ) : (
                        "no chart"
                      )
                    )}
                  </Row>
                </Row>
              )}
            </>
          ) : (
            <NetZeroLoader addZIndex={true} />
          )}
        </Col>

        <Col lg={2} className={`d-${showFilter ? "block" : "none"}`}>
          <RightFilter applyFilter={applyFilter} />
        </Col>
      </Row>
    </>
  );
};

export default TMDashboard;
